export default __webpack_public_path__ + "static/media/383.3a091cd4.jpg";